import script from "./WeeklySalesChart.vue?vue&type=script&setup=true&lang=js"
export * from "./WeeklySalesChart.vue?vue&type=script&setup=true&lang=js"

import "./WeeklySalesChart.vue?vue&type=style&index=0&id=581f3ce6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-581f3ce6"]])

export default __exports__